import './App.css';
import { useEffect, useRef, useState } from 'react';
import SpinWheel from './SpinWheel';
import ConfettiExplosion from 'react-confetti-explosion';
import Confetti from 'react-confetti'
import { useWindowSize } from 'react-use'
import axios from 'axios';
import { useParams } from "react-router-dom";
import ReactCanvasConfetti from "react-canvas-confetti";
import { cssTransition, ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Test1 from './Test1';
import CustomCopytoClip from './CustomCopytoClip';

import * as localForage from "localforage";
import { useNavigate } from 'react-router-dom';

const canvasStyles = {
  position: "fixed",
  pointerEvents: "none",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0
};

let animationInstance = null;

function Main1() {
const { id } = useParams(); // Extract the ID from the URL
const { user } = useParams(); // Extract the ID from the URL
  const containerRef1 = useRef(null);
  const { width, height } = useWindowSize()
  const [spin, setSpin] = useState(true)
  const [loader, setLoader] = useState(true)
  const [T, setT] = useState(true)
  const [deal, setDeal] = useState([])
  const [brand, setBrand] = useState()
  const [eway, setEWay] = useState()
  const [pass, setPass] = useState()
  const [points, setPoints] = useState()
  const [redeeming, setRedeeming] = useState([])
  const [Widget, setWidget] = useState()


    const navigate = useNavigate();
    async function onloadd() {
        const user = await localForage.getItem('pass'); 
        if(user?._id && user.brandId === id ) navigate('/'+id+'/'+user._id);

        // setLoader(false)
    }
    useEffect(() => onloadd, [])



//   
const makeShot = (particleRatio, opts) => {
    animationInstance &&
      animationInstance({
        ...opts,
        origin: { y: 0.7 },
        particleCount: Math.floor(200 * particleRatio)
      });
  };

  const fire = () => {
    makeShot(0.25, {
      spread: 26,
      startVelocity: 55
    });

    makeShot(0.2, {
      spread: 60
    });

    makeShot(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8
    });

    makeShot(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2
    });

    makeShot(0.1, {
      spread: 120,
      startVelocity: 45
    });
  };

  const getInstance = (instance) => {
    animationInstance = instance;
  };
//   






  const scrollLeft1 = () => {
    if (containerRef1.current) {
      containerRef1.current.scrollBy({
        left: -200, // Scroll 200px to the left
        behavior: "smooth", // Smooth scrolling
      });
    }
  };

  const scrollRight1 = () => {
    if (containerRef1.current) {
      containerRef1.current.scrollBy({
        left: 200, // Scroll 200px to the right
        behavior: "smooth", // Smooth scrolling
      });
    }
  };


  const containerRef = useRef(null);

  const scrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: -200, // Scroll 200px to the left
        behavior: "smooth", // Smooth scrolling
      });
    }
  };

  const scrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: 200, // Scroll 200px to the right
        behavior: "smooth", // Smooth scrolling
      });
    }
  };

//   const Slide = cssTransition({
//     enter: 'slideIn',
//     exit: 'slideOut',
//     appendPosition: false,
//     collapse: true,
//     collapseDuration: 300
//   });

async function onload() {
    setLoader(true)
    const brand = await axios.get('https://api.walletly.ai/api/v4/brand?_id='+id);
    console.log('brand',brand);
    if(brand?.data?.data?.length>0) setBrand(brand.data.data[0])
    
      try {
        const widget = await axios.get('https://api.walletly.ai/api/v4/growthtool?brandId='+id+'&growthtoolType=widget');
        console.log('widget',widget);
        if(widget?.data?.data?.length>0) setWidget(widget.data.data[0])
        
      } catch (error) {
          console.log(error);
          
      }

      try {
          const transaction = await axios.get('https://api.walletly.ai/api/v4/transaction?brandId='+id+'&passId='+user+'&type=spinwheel&created='+(new Date().valueOf()));
          console.log('transaction',transaction);
          if(transaction?.data?.data?.length>0) setT(false)
          
      } catch (error) {
          console.log(error);
          setT(false)
          
      }
    
    const ew = await axios.get('https://api.walletly.ai/api/v4/earning/public?brandId='+id+'&active=true&activity=spending');
    console.log('ew',ew);
    if(ew?.data?.data?.length>0) setEWay(ew.data.data[0])
    
      console.log('user',user);
      
      try {
          const pass = await axios.get('https://api.walletly.ai/api/v4/pass/public?_id='+user);
          console.log('pass',pass);
          if(pass?.data?.data?.length>0) setPass(pass.data.data[0])
      } catch (error) {
          console.log(error);
      }
    
    const response1 = await axios.post('https://api.walletly.ai/api/v4/deal/getBrandDeals',{brandId: id});
    console.log('response123',response1);
    // if(response1?.data?.data) setDeal([...response1?.data?.data])
    let temppo = []
    if(response1?.data?.data){
      for (const element of response1?.data?.data) {
        if(element?.popular === true) temppo.push(element)
      }
      // setDeal([...response1?.data?.data])
      setDeal([...temppo])

    }

    const response = await axios.get('https://api.walletly.ai/api/v4/redeeming/widget?brandId='+id+'&redeemingWayType=product');
    console.log('response333',response);

    let tempRedeemingWays = []
    if(response1?.data?.data?.length>0 && response?.data?.data?.length>0){
      for (const redeem of response?.data?.data) {
          for (const deal of response1?.data?.data) {
            console.log('redeem?.rewardValue?.rewardDealId',redeem?.rewardValue?.rewardDealId);
            console.log('deal?._id',deal?._id);
            console.log('redeem.active',redeem.active);
            console.log('redeem.delete',redeem.delete);
            
              if(redeem?.rewardValue?.rewardDealId === deal?._id && redeem.active && !redeem.delete) tempRedeemingWays.push({...redeem, rewardValue: {...redeem?.rewardValue, product: deal}})
          }
      }
    }
    setRedeeming([...tempRedeemingWays])
    console.log('tempRedeemingWays',tempRedeemingWays);
    
    setLoader(false)
  }

// useEffect(() => onload, [])
useEffect(() => {
  onload()
}, [])



async function onload1() {
    try {
        
        const response1 = await axios.post('https://api.walletly.ai/api/v4/transaction/businessCheckout1',{
                    passId: user,
                    brandId: id,
                    type: 'spinwheel',
                    platform: 'widget',
                    amount: parseInt(points),
                  });
                  console.log('response1',response1);
                } catch (error) {
                    
                    console.log('error',error);
    }
}

useEffect(() => {
    console.log('1',spin,T);
    if(spin===false){
        if(user){
            console.log('2');
            if(T===true){
                console.log('3');
                fire()
                console.log('4');
                toast.success(`Congratulations! You earned ${points} points.🥳🥳`, {
                    position: "top-center",
                    autoClose: 3000, // Auto-dismiss after 3 seconds
                    hideProgressBar: false,
                    closeOnClick: false, // Prevent closing on click
                    pauseOnHover: false, // Prevent pausing on hover
                    draggable: false, // Prevent dragging to dismiss
                    progress: undefined, // Show default progress bar
                    theme: "light", // Set theme to light
                    transition: Slide, // Use Slide transition
                  });
                  console.log('5');
                  setT(false)
                  console.log('6');
                  onload1()
            }
            else{
                console.log('7');
                toast.error(`You cannot run this twice a day`, {
                    position: "top-center",
                    autoClose: 3000, // Auto-dismiss after 3 seconds
                    hideProgressBar: false,
                    closeOnClick: false, // Prevent closing on click
                    pauseOnHover: false, // Prevent pausing on hover
                    draggable: false, // Prevent dragging to dismiss
                    progress: undefined, // Show default progress bar
                    theme: "light", // Set theme to light
                    transition: Slide, // Use Slide transition
                  });
                  console.log('8');
                }
            }
            else{
            toast.error(`You cannot run this without login`, {
                position: "top-center",
                autoClose: 3000, // Auto-dismiss after 3 seconds
                hideProgressBar: false,
                closeOnClick: false, // Prevent closing on click
                pauseOnHover: false, // Prevent pausing on hover
                draggable: false, // Prevent dragging to dismiss
                progress: undefined, // Show default progress bar
                theme: "light", // Set theme to light
                transition: Slide, // Use Slide transition
              });

        }
        console.log('9');
        setTimeout(() => {
          console.log('10');
          setSpin(true)
          console.log('11');
        }, 3000);
        console.log('12');
    }
}, [spin])


useEffect(() => {
    setTimeout(() => {
        console.log('Tabcdef',T);
        const canvas = document.getElementById('canvas');
        console.log('canvasabcdef',canvas);
        
      if (canvas?.style?.pointerEvents) {
        console.log('Tabcdddd',T);
        if(!T){
        canvas.style.pointerEvents = 'none'
        canvas.style.cursor = 'not-allowed'
        canvas.style.pointerEvents = 'none !important'
        canvas.style.cursor = 'not-allowed !important'
        }
    }
    else console.error('Canvas element not found!')
    }, 5000);
    
}, [T])

//   useEffect(() => onload1, [spin])

  
  
  function capitalizeFirstLetter(str) {
    if (!str) return str; // Handle empty string
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return (
    <div>
        {loader?<div className='loaderH'>
            {console.log('eway',eway)}
            {console.log('widget1',Widget)}
            <div class="loader"></div></div>:<div>
            <ToastContainer />
            <header className='header'>
                <img height={72} src={brand?.brandLogo} />
                <div>
                <div className='account'>Your Account</div>
                <div onClick={()=>navigate('/'+id+'/login')} className={pass?.userData?.firstName? 'name' : "name cp"}>{capitalizeFirstLetter(pass?.userData?.firstName) || "Sign In"}</div>
                </div>
            </header>
            <div className='m-75 m-8-mob' style={{marginTop: '0px'}}>
                <div className='d-flex align-items-center mob-column justify-content-right mt-20'>
                {pass?.loyaltyCard?.currentPoints&&<div className='BalanceDiv'>
                <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="25.6667" cy="26.0197" r="21.6255" fill="#FEC424" stroke="url(#paint0_linear_1203_5041)" stroke-width="8.08226"/>
                    <circle cx="25.6667" cy="26.0197" r="25.1768" stroke="url(#paint1_linear_1203_5041)" stroke-width="0.979668"/>
                    <circle cx="25.6672" cy="26.1237" r="18.3701" stroke="url(#paint2_linear_1203_5041)" stroke-width="0.734751"/>
                    <g filter="url(#filter0_dddd_1203_5041)">
                    <path d="M24.0901 15.2887C24.7549 14.173 26.3707 14.173 27.0355 15.2887L29.4747 19.3817C29.715 19.7849 30.1101 20.0719 30.5679 20.1759L35.2143 21.2309C36.4808 21.5184 36.9801 23.0551 36.1245 24.0322L32.9856 27.6168C32.6763 27.9699 32.5254 28.4344 32.568 28.9018L33.0005 33.6469C33.1184 34.9403 31.8112 35.89 30.6175 35.3782L26.2384 33.5006C25.807 33.3156 25.3186 33.3156 24.8872 33.5006L20.5081 35.3782C19.3144 35.89 18.0072 34.9403 18.1251 33.6469L18.5576 28.9018C18.6002 28.4344 18.4493 27.9699 18.1401 27.6168L15.0011 24.0322C14.1455 23.0551 14.6448 21.5184 15.9113 21.2309L20.5578 20.1759C21.0155 20.0719 21.4106 19.7849 21.6509 19.3817L24.0901 15.2887Z" fill="#FED545"/>
                    </g>
                    <defs>
                    <filter id="filter0_dddd_1203_5041" x="10.9014" y="13.9618" width="26.6288" height="28.9047" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="0.244917"/>
                    <feGaussianBlur stdDeviation="0.367375"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1203_5041"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dx="-0.489834" dy="1.22458"/>
                    <feGaussianBlur stdDeviation="0.734751"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"/>
                    <feBlend mode="normal" in2="effect1_dropShadow_1203_5041" result="effect2_dropShadow_1203_5041"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dx="-0.979668" dy="2.939"/>
                    <feGaussianBlur stdDeviation="0.979668"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
                    <feBlend mode="normal" in2="effect2_dropShadow_1203_5041" result="effect3_dropShadow_1203_5041"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dx="-1.4695" dy="5.14326"/>
                    <feGaussianBlur stdDeviation="1.10213"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"/>
                    <feBlend mode="normal" in2="effect3_dropShadow_1203_5041" result="effect4_dropShadow_1203_5041"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow_1203_5041" result="shape"/>
                    </filter>
                    <linearGradient id="paint0_linear_1203_5041" x1="44.071" y1="7.0639" x2="10.1141" y2="46.2227" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FED64A"/>
                    <stop offset="0.123016" stop-color="#FEF14E"/>
                    <stop offset="0.248796" stop-color="#FFDF6C"/>
                    <stop offset="0.482583" stop-color="#FCFF67"/>
                    <stop offset="0.743348" stop-color="#FED545"/>
                    <stop offset="0.82597" stop-color="#FECA45"/>
                    <stop offset="1" stop-color="#FEED44"/>
                    </linearGradient>
                    <linearGradient id="paint1_linear_1203_5041" x1="20.6161" y1="0.353027" x2="26.8577" y2="51.6864" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FFF3C4"/>
                    <stop offset="0.483894" stop-color="#EDC071"/>
                    <stop offset="0.961122" stop-color="#BF8147"/>
                    </linearGradient>
                    <linearGradient id="paint2_linear_1203_5041" x1="20.9906" y1="7.38623" x2="37.9083" y2="40.7756" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#C8892B"/>
                    <stop offset="0.979601" stop-color="#FFEDA3"/>
                    </linearGradient>
                    </defs>
                </svg>
                <div className='pts'>{pass?.loyaltyCard?.currentPoints}</div><div className='ptsText'>Pts</div>
                </div>}
                <div className='w-50 d-flex justify-content-right'>
                  <div className='inbox'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                      <path d="M15.1465 22.1827H18.4789V25.5151H15.1465V22.1827ZM15.1465 8.8541H18.4789V18.8503H15.1465V8.8541ZM16.7957 0.520996C13.5013 0.524429 10.2819 1.50445 7.5443 3.33719C4.80674 5.16994 2.67396 7.77313 1.41554 10.8177C0.157118 13.8623 -0.170451 17.2117 0.474236 20.4424C1.11892 23.6731 2.70692 26.6402 5.03752 28.9686C7.36812 31.297 10.3367 32.8822 13.568 33.5239C16.7993 34.1656 20.1484 33.8348 23.1918 32.5736C26.2352 31.3123 28.8364 29.1771 30.6666 26.4378C32.4967 23.6985 33.4738 20.4781 33.4741 17.1837C33.4751 14.994 33.0443 12.8256 32.2063 10.8026C31.3683 8.77961 30.1395 6.94174 28.5904 5.39419C27.0412 3.84664 25.202 2.6198 23.1782 1.78389C21.1543 0.947986 18.9854 0.519422 16.7957 0.522732V0.520996ZM16.8122 30.5115C14.1761 30.5113 11.5992 29.7294 9.40739 28.2647C7.21561 26.8 5.50738 24.7183 4.49873 22.2827C3.49008 19.8471 3.2263 17.1672 3.74076 14.5817C4.25521 11.9963 5.52479 9.62141 7.38896 7.75749C9.25312 5.89357 11.6281 4.62429 14.2137 4.11017C16.7992 3.59605 19.4791 3.86018 21.9145 4.86915C24.35 5.87812 26.4315 7.58662 27.8959 9.77859C29.3604 11.9706 30.1419 14.5476 30.1417 17.1837C30.1423 18.9343 29.7979 20.6679 29.1282 22.2854C28.4586 23.9028 27.4768 25.3725 26.2389 26.6104C25.001 27.8482 23.5313 28.8301 21.9139 29.4997C20.2964 30.1694 18.5628 30.5138 16.8122 30.5132V30.5115Z" fill="white"/>
                    </svg>
                  </div>
                  <div className='textinbox two-line-ellipsis'>
                    {Widget?.widget?.description}
                    {/* "Have 5 points? Get $5 off your order! Click my offers below & sign in with your email address to view your points. Use promo code 'REWARDS' at checkout to redeem them. Orders over $10 earn a point." */}
                  </div>
                  </div>
              </div>

                {Widget?.widget?.wheel&&<div className='d-flex align-items-end place-content-space-between border pb-8'>
                <div className='special'>Games</div>
                {/* <div className='d-flex gap-24'>
                    <div className='left'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                        <path d="M6.63147 17.9995H29.3683" stroke="#353945" stroke-width="2.13158" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.7366 25.1051C13.7366 25.1051 6.63143 19.8722 6.63143 17.9998C6.63143 16.1274 13.7367 10.8945 13.7367 10.8945" stroke="#353945" stroke-width="2.13158" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    </div>
                    <div className='right'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                        <path d="M29.3685 17.9995H6.63171" stroke="#353945" stroke-width="2.13158" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M22.2634 25.1051C22.2634 25.1051 29.3686 19.8722 29.3686 17.9998C29.3686 16.1274 22.2633 10.8945 22.2633 10.8945" stroke="#353945" stroke-width="2.13158" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    </div>
                </div> */}
                </div>}

                {Widget?.widget?.wheel&&<div className={'mb-550'}><Test1 spin={spin} setSpin={setSpin} setPoints={setPoints} widget={Widget} /></div>}
                {Widget?.widget?.wheel&&<ReactCanvasConfetti refConfetti={getInstance} style={canvasStyles} />}

                {Widget?.widget?.wheel&&<ReactCanvasConfetti refConfetti={getInstance} style={canvasStyles} />}

{console.log('redeeming',redeeming)}

                {redeeming.length>0&&<div className='d-flex align-items-end place-content-space-between border pb-8'>
                <div className='special'>Loyalty</div>
                </div>}


                <div className='d-flex gap-30' 
                ref={containerRef1}
                style={{
                    display: "flex",
                    overflowX: "auto",
                }}
                >
                {redeeming.length>0&&redeeming.map((value,index)=>(
                  (value.widget===false)&&<div className='dealwidth'>
                    <img className='dealimage' src={value?.rewardValue?.product?.image} />
                    <div className='dealtext'>{value?.rewardValue?.product?.name}</div>
                    <div className='dealrating'>{"Required "+value?.rewardValue?.costingPoint+" Points"}</div>
                    <div className='d-flex gap-10'>
                      <div className='grabit2 cp' onClick={()=>window.open(brand.website, '_blank')}>
                          {/* {value?.rewardValue?.cwCode} */}
                          Order Now
                        </div>
                        <div className='grabit1'>
                            {/* {value?.rewardValue?.cwCode} */}
                            Copy code
                            <CustomCopytoClip
                              data={value?.rewardValue?.cwCode}
                              icon={<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                  <path d="M11.6368 18.7192C11.6368 15.2597 11.6368 13.5299 12.7116 12.4551C13.7864 11.3804 15.5162 11.3804 18.9757 11.3804H20.1988C23.6584 11.3804 25.3881 11.3804 26.4629 12.4551C27.5377 13.5299 27.5377 15.2597 27.5377 18.7192V19.9424C27.5377 23.4019 27.5377 25.1316 26.4629 26.2064C25.3881 27.2812 23.6584 27.2812 20.1988 27.2812H18.9757C15.5162 27.2812 13.7864 27.2812 12.7116 26.2064C11.6368 25.1316 11.6368 23.4019 11.6368 19.9424V18.7192Z" stroke="#FF511E" stroke-width="1.83471" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M21.4215 11.3803C21.4185 7.76341 21.3638 5.88992 20.311 4.60712C20.1077 4.35938 19.8805 4.13223 19.6329 3.92892C18.2796 2.81836 16.2691 2.81836 12.248 2.81836C8.22697 2.81836 6.21644 2.81836 4.86322 3.92892C4.61549 4.13222 4.38834 4.35938 4.18503 4.60712C3.07446 5.96034 3.07446 7.97086 3.07446 11.9919C3.07446 16.013 3.07446 18.0235 4.18503 19.3767C4.38832 19.6244 4.61549 19.8516 4.86322 20.0549C6.14603 21.1077 8.01951 21.1624 11.6364 21.1653" stroke="#FF511E" stroke-width="1.83471" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>}
                            />
                          </div>

                    </div>
                </div>))}
                </div>


                {deal.length>0&&<div className='d-flex align-items-end place-content-space-between border pb-8 mt-40'>
                <div className='special'>Specials</div>
                </div>}
                
                <div className='d-flex gap-30' 
                ref={containerRef}
                style={{
                    display: "flex",
                    overflowX: "auto",
                }}
                >
                {deal.length>0&&deal.map((value,index)=>(value?.popular&&<div className='dealwidth'>
                    <img className='dealimage' src={value.image} />
                    <div className='dealtext'>{value?.name}</div>
                    <div className='dealrating'>{value?.rating||'4.5'} <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                    <path d="M9.09822 1.75715L10.2208 4.02079C10.3739 4.3359 10.782 4.63814 11.1265 4.69602L13.1611 5.03685C14.4622 5.2555 14.7684 6.20726 13.8308 7.14616L12.249 8.74098C11.9811 9.01106 11.8345 9.53195 11.9173 9.90498L12.3702 11.8792C12.7274 13.4419 11.9046 14.0464 10.5333 13.2297L8.62626 12.0914C8.28187 11.8857 7.71422 11.8857 7.36338 12.0914L5.45636 13.2297C4.09145 14.0464 3.2623 13.4355 3.61947 11.8792L4.07232 9.90498C4.15523 9.53195 4.00853 9.01106 3.74065 8.74098L2.15889 7.14616C1.22769 6.20726 1.52746 5.2555 2.82859 5.03685L4.8632 4.69602C5.20124 4.63814 5.60943 4.3359 5.76251 4.02079L6.88504 1.75715C7.49734 0.528867 8.4923 0.528867 9.09822 1.75715Z" fill="#FFCB00" stroke="#FFCB00" stroke-width="1.5947" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg> {"("+(value?.orders||"7,000+")+")"}
                    </div>
                    <div className='grabit' onClick={()=>window.open(brand.website, '_blank')}>Grab it</div>
                </div>))}
                </div>


                <div className='updateInfoBlock'>
                <div className='updateInfo'>Update Your Info</div>
                <div className='d-flex gap-10 overflowxautomob'>
                    <div className='updateInfoSub cp' onClick={()=>window.open('https://bday.walletly.ai', '_blank')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="61" height="61" viewBox="0 0 61 61" fill="none">
                        <path d="M34.582 11.5493C34.582 13.6204 32.903 15.2993 30.832 15.2993C28.761 15.2993 27.082 13.6204 27.082 11.5493C27.082 9.47824 30.832 5.29932 30.832 5.29932C30.832 5.29932 34.582 9.47824 34.582 11.5493Z" stroke="#141B34" stroke-width="1.92701" stroke-linejoin="round"/>
                        <path d="M30.832 15.2993V22.7993" stroke="#141B34" stroke-width="1.92701" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M44.9988 35.2993C48.9108 35.2993 52.082 32.5011 52.082 29.0493C52.082 25.5976 48.9108 22.7993 44.9988 22.7993H16.6654C12.7534 22.7993 9.58203 25.5976 9.58203 29.0493C9.58203 32.5011 12.7534 35.2993 16.6654 35.2993C20.0922 35.2993 23.0924 33.1521 23.7487 30.2993C24.405 33.1521 27.4053 35.2993 30.832 35.2993C34.2588 35.2993 37.259 33.1521 37.9153 30.2993C38.5718 33.1521 41.5718 35.2993 44.9988 35.2993Z" stroke="#141B34" stroke-width="1.92701" stroke-linejoin="round"/>
                        <path d="M13.332 35.2993L14.6343 41.7483C15.9453 48.2413 16.6009 51.4878 18.8222 53.3936C21.0436 55.2993 24.1722 55.2993 30.4295 55.2993H31.2345C37.4918 55.2993 40.6205 55.2993 42.8418 53.3936C45.0633 51.4878 45.7188 48.2413 47.0298 41.7483L48.332 35.2993" stroke="#141B34" stroke-width="1.92701" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div className='updateInfoText'>Update your birthday</div>
                    </div>
                    <div className='updateInfoSub cp' onClick={()=>window.open('https://social.walletly.ai', '_blank')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="61" height="61" viewBox="0 0 61 61" fill="none">
                        <path d="M6.35962 30.7007C6.35962 19.5048 6.35962 13.9069 9.83772 10.4288C13.3158 6.95068 18.9138 6.95068 30.1096 6.95068C41.3054 6.95068 46.9034 6.95068 50.3816 10.4288C53.8596 13.9069 53.8596 19.5048 53.8596 30.7007C53.8596 41.8964 53.8596 47.4944 50.3816 50.9727C46.9034 54.4507 41.3054 54.4507 30.1096 54.4507C18.9138 54.4507 13.3158 54.4507 9.83772 50.9727C6.35962 47.4944 6.35962 41.8964 6.35962 30.7007Z" stroke="#141B34" stroke-width="1.92701" stroke-linejoin="round"/>
                        <path d="M41.3593 30.7007C41.3593 36.9139 36.3225 41.9507 30.1093 41.9507C23.8961 41.9507 18.8593 36.9139 18.8593 30.7007C18.8593 24.4875 23.8961 19.4507 30.1093 19.4507C36.3225 19.4507 41.3593 24.4875 41.3593 30.7007Z" stroke="#141B34" stroke-width="1.92701"/>
                        <path d="M43.8776 16.9507H43.856" stroke="#141B34" stroke-width="2.56934" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div className='updateInfoText'>Link your Social Media</div>
                    </div>
                </div>
                </div>


                {eway?.earningType === "incremental"||eway?.earningType === "fixed"&&<div className='justify-items-center mt-100 d-flex align-items-center' style={{flexDirection: 'column'}}>
                <img height={65} src={brand?.brandLogo} />
                <div className='bottom mt-20 mb-35'>Start earning points to redeem<br/>towards your favorite menu items</div>
                <div className='d-flex gap-40 align-items-center'>
                    <div>
                    <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M42.9644 38.3096C38.546 38.3096 34.9644 41.2914 34.9644 44.9696C34.9644 48.6479 38.546 51.6296 42.9644 51.6296C47.3828 51.6296 50.9644 54.6119 50.9644 58.2901C50.9644 61.9679 47.3828 64.9501 42.9644 64.9501M42.9644 38.3096C46.4476 38.3096 49.4108 40.163 50.5092 42.7496M42.9644 38.3096V33.8696M42.9644 64.9501C39.4812 64.9501 36.518 63.0967 35.4196 60.5101M42.9644 64.9501L42.9756 69.4252" stroke="#141B34" stroke-width="4.65517" stroke-linecap="round"/>
                        <path d="M78.9648 38.3139C79.592 37.9623 80.1372 37.5192 80.6216 36.9605C82.9648 34.2583 82.9648 29.9091 82.9648 21.2106C82.9648 12.5121 82.9648 8.16283 80.6216 5.46057C78.2784 2.7583 74.5072 2.7583 66.9648 2.7583H18.9648C11.4224 2.7583 7.65112 2.7583 5.308 5.46057C2.96484 8.16283 2.96484 12.5121 2.96484 21.2106C2.96484 29.9091 2.96484 34.2583 5.308 36.9605C5.79236 37.5192 6.33772 37.9623 6.96484 38.3139" stroke="#141B34" stroke-width="4.65517" stroke-linecap="round"/>
                        <path d="M42.9648 82.7579C58.4288 82.7579 70.9648 68.8289 70.9648 51.6468C70.9648 34.4646 58.4288 20.5356 42.9648 20.5356C27.5009 20.5356 14.9648 34.4646 14.9648 51.6468C14.9648 68.8289 27.5009 82.7579 42.9648 82.7579Z" stroke="#141B34" stroke-width="4.65517"/>
                        <path d="M14.9648 20.5356H70.9648" stroke="#141B34" stroke-width="4.65517" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div className='bottom'>{(eway?.earningType === "fixed"?eway?.earningValue:eway?.earningType === "incremental"?'1':'-')+" "+(brand?.currency?.symbol || '$')}</div>
                    <div className='bottom'>Spent</div>
                    </div>
                    <div>
                    <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.4604 9.24072H12.7363C9.02259 9.24072 6.01212 12.2512 6.01212 15.9649C6.01212 19.6785 9.02259 22.689 12.7363 22.689H29.9202" stroke="#141B34" stroke-width="2.24138" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M25.4374 18.2065C25.4374 18.2065 29.9202 21.5081 29.9202 22.6893C29.9202 23.8707 25.4374 27.1721 25.4374 27.1721" stroke="#141B34" stroke-width="2.24138" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    </div>
                    <div>
                    <svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="40.2764" cy="40.2065" r="33.9111" fill="#FEC424" stroke="url(#paint0_linear_1203_5264)" stroke-width="12.1779"/>
            <circle cx="40.2764" cy="40.2065" r="39.2619" stroke="url(#paint1_linear_1203_5264)" stroke-width="1.47611"/>
            <circle cx="40.2765" cy="40.3683" r="28.6478" stroke="url(#paint2_linear_1203_5264)" stroke-width="1.10708"/>
            <g filter="url(#filter0_dddd_1203_5264)">
            <path d="M37.8945 23.3549C38.8963 21.6739 41.3308 21.6739 42.3326 23.3549L46.2295 29.894C46.5916 30.5016 47.1869 30.9341 47.8766 31.0907L55.2999 32.7762C57.2082 33.2095 57.9605 35.5248 56.6713 36.997L51.6565 42.7239C51.1905 43.256 50.9631 43.9559 51.0273 44.6602L51.7183 52.241C51.8959 54.1898 49.9264 55.6208 48.1278 54.8496L41.1315 51.8499C40.4815 51.5712 39.7456 51.5712 39.0956 51.8499L32.0994 54.8496C30.3008 55.6208 28.3313 54.1898 28.5089 52.241L29.1998 44.6602C29.264 43.9559 29.0366 43.256 28.5707 42.7239L23.5558 36.997C22.2666 35.5248 23.0189 33.2095 24.9273 32.7762L32.3506 31.0907C33.0402 30.9341 33.6356 30.5016 33.9976 29.894L37.8945 23.3549Z" fill="#FED545"/>
            </g>
            <defs>
            <filter id="filter0_dddd_1203_5264" x="17.3787" y="21.3562" width="41.4104" height="44.7766" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="0.369027"/>
            <feGaussianBlur stdDeviation="0.55354"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1203_5264"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dx="-0.738054" dy="1.84513"/>
            <feGaussianBlur stdDeviation="1.10708"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"/>
            <feBlend mode="normal" in2="effect1_dropShadow_1203_5264" result="effect2_dropShadow_1203_5264"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dx="-1.47611" dy="4.42832"/>
            <feGaussianBlur stdDeviation="1.47611"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
            <feBlend mode="normal" in2="effect2_dropShadow_1203_5264" result="effect3_dropShadow_1203_5264"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dx="-2.21416" dy="7.74956"/>
            <feGaussianBlur stdDeviation="1.66062"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"/>
            <feBlend mode="normal" in2="effect3_dropShadow_1203_5264" result="effect4_dropShadow_1203_5264"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow_1203_5264" result="shape"/>
            </filter>
            <linearGradient id="paint0_linear_1203_5264" x1="68.9584" y1="10.665" x2="16.0386" y2="71.6917" gradientUnits="userSpaceOnUse">
            <stop stop-color="#FED64A"/>
            <stop offset="0.123016" stop-color="#FEF14E"/>
            <stop offset="0.248796" stop-color="#FFDF6C"/>
            <stop offset="0.482583" stop-color="#FCFF67"/>
            <stop offset="0.743348" stop-color="#FED545"/>
            <stop offset="0.82597" stop-color="#FECA45"/>
            <stop offset="1" stop-color="#FEED44"/>
            </linearGradient>
            <linearGradient id="paint1_linear_1203_5264" x1="32.4054" y1="0.206543" x2="42.1325" y2="80.2065" gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFF3C4"/>
            <stop offset="0.483894" stop-color="#EDC071"/>
            <stop offset="0.961122" stop-color="#BF8147"/>
            </linearGradient>
            <linearGradient id="paint2_linear_1203_5264" x1="32.9883" y1="11.167" x2="59.3535" y2="63.2023" gradientUnits="userSpaceOnUse">
            <stop stop-color="#C8892B"/>
            <stop offset="0.979601" stop-color="#FFEDA3"/>
            </linearGradient>
            </defs>
                    </svg>
                    <div className='bottom'>{eway?.earningType === "incremental"?eway?.earningValue:eway?.earningType === "fixed"?'1':'-'}</div>
                    <div className='bottom'>Point</div>
                    </div>
                </div>
                </div>}

                <div style={{marginBottom: '200px'}}></div>

            </div>
        </div>}













      {/* <ConfettiExplosion /> */}
    </div>
  );
}

export default Main1;